import React from "react";

const ChatConfigContext = React.createContext({
  chatCongig: {
    id: "",
    image: "", // Image uploader
    title: "", // Text input
    aiEngine: "", // Select
    welcomeMessage: "", // Textarea
    questionsSuggestions: [""], // Array of text inputs
  },
  setChatConfig: () => {},
}); // default value is 'light'

export default ChatConfigContext;
